<script>
import GenericCrud from "@forms/GenericCrud.vue";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Consultor"
    }
  }  
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Nome" label-for="nome">
        <b-form-input
          id="nome"
          v-model="item.nome"
          type="text"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="CPF" label-for="cpf">
        <b-form-input
          id="cpf"
          v-model="item.cpf"
          :disabled="!this.editForm"
          v-mask="'###.###.###-##'"
          placeholder="000.000.000-00"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="Telefone" label-for="telefone">
        <b-form-input
          id="telefone"
          v-model="item.telefone"
          :disabled="!this.editForm"
          v-mask="'(##) #####-####'"
          placeholder="(00) 00000-0000"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="E-mail" label-for="email">
        <b-form-input
          id="email"
          v-model="item.email"
          type="text"
          :disabled="!this.editForm"
          required
        ></b-form-input>
        
      </b-form-group>
      <b-form-group
        id="input-group-ativo"
        label-for="ativo"
        class="mt-3 text-left"
        v-show="item.id != null"
      >
        <b-form-checkbox v-model="item.usuarioAtivo"
          >Ativo
        </b-form-checkbox>
      </b-form-group>
      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
      
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
